/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ApplicationCredentialsDto, ProductSwitchIntentDto, StatusDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class OrganisationProductSwitchIntentController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags organisation-product-switch-intent-controller
   * @name UpdateProductSwitchIntent
   * @request PUT:/api/v1/organisations/product-switch-intent/{id}
   */
  updateProductSwitchIntent = (
    id: string,
    data: ProductSwitchIntentDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ProductSwitchIntentDto, any>({
      path: `/v1/organisations/product-switch-intent/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateProductSwitchIntentPath = '/v1/organisations/product-switch-intent/${id}'
  static updateProductSwitchIntentMethod = 'PUT'
  /**
   * No description
   *
   * @tags organisation-product-switch-intent-controller
   * @name CreateProductSwitchIntent
   * @request POST:/api/v1/organisations/product-switch-intent
   */
  createProductSwitchIntent = (params: RequestParams = {}) =>
    this.http.request<ProductSwitchIntentDto, any>({
      path: `/v1/organisations/product-switch-intent`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static createProductSwitchIntentPath = '/v1/organisations/product-switch-intent'
  static createProductSwitchIntentMethod = 'POST'
  /**
   * No description
   *
   * @tags organisation-product-switch-intent-controller
   * @name CheckEligibility
   * @request POST:/api/v1/organisations/product-switch-intent/{id}/check-eligibility
   */
  checkEligibility = (id: string, params: RequestParams = {}) =>
    this.http.request<StatusDto, any>({
      path: `/v1/organisations/product-switch-intent/${id}/check-eligibility`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static checkEligibilityPath = '/v1/organisations/product-switch-intent/${id}/check-eligibility'
  static checkEligibilityMethod = 'POST'
  /**
   * No description
   *
   * @tags organisation-product-switch-intent-controller
   * @name ApplyForCredit
   * @request POST:/api/v1/organisations/product-switch-intent/{id}/apply-to-credit
   */
  applyForCredit = (id: string, params: RequestParams = {}) =>
    this.http.request<ApplicationCredentialsDto, any>({
      path: `/v1/organisations/product-switch-intent/${id}/apply-to-credit`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static applyForCreditPath = '/v1/organisations/product-switch-intent/${id}/apply-to-credit'
  static applyForCreditMethod = 'POST'
}
